import React from "react";

export default function SkeletonCard() {
  return (
    <div className="animate-pulse rounded-2xl border border-slate-200 p-6">
      <div className="h-6 w-3/5 rounded bg-slate-200" />
      <div className="mt-4 space-y-2">
        <div className="h-4 w-1/2 rounded bg-slate-200" />
        <div className="h-4 w-2/3 rounded bg-slate-200" />
        <div className="h-4 w-1/3 rounded bg-slate-200" />
      </div>
      <div className="mt-6 h-8 w-24 rounded bg-slate-200" />
    </div>
  );
}
